
import { Component, Vue, Watch } from 'vue-property-decorator';
// Utils
import Rules from '@/shared/utils/rules.util';
import Mask from '@/shared/utils/masks.util';
// Service
import UsuarioInternoService from '@/services/usuario-interno.service';
// Interface
import { RecuperacaoInterface } from '@/shared/models/recuperacao/recuperacao.interface';
import redirectUtil from '@/shared/utils/redirect.util';

@Component({})
export default class AlterarSenha extends Vue {
  public recuperacao = {} as RecuperacaoInterface;

  public novaSenha = '';

  public equal: string | boolean = true;

  public rules = Rules;

  public mask = Mask;

  public mostrarSenha = false;

  public mostrarSenha2 = false;

  async alterarSenha() {
    if ((this.$refs.formAlterarSenha as HTMLFormElement).validate()) {
      await new UsuarioInternoService().alterarSenha(this.recuperacao, this);
    }
  }

  voltar() {
    this.$router.go(-1);
  }

  senhaEqual() {
    this.equal = this.novaSenha !== this.recuperacao.novaSenha
      ? 'Senhas digitadas não são iguais!'
      : true;
    return this.novaSenha !== this.recuperacao.novaSenha
      ? 'Senhas digitadas não são iguais!'
      : true;
  }

  created() {
    this.recuperacao.cpf = '';
    this.recuperacao.codigo = '';
    this.recuperacao.novaSenha = '';
    if (this.$route.params.dados && (this.$route.params.dados as any).cpf) {
      this.recuperacao.cpf = (this.$route.params.dados as any).cpf;
    } else {
      redirectUtil.redirecionar(this, 'login', null);
    }
  }
}
